import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import { FC, ReactElement, useEffect, useState } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AlertDialog from '../../../components/dialog/AlertDialog';
import React from 'react';

const modalTextStyle = { color: '#1F1F1F', fontSize: '14px' };

const mockData = [
  {
    id: 'b887ed17-c27c-4279-9a28-c3ee90645ac6',
    name: '17846546-4A9E-4E16-AE81-786107496FF4.jpg',
    storeable_asset_id: '5708d646-167c-4b44-9497-530a3c8ebf6f',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:50.981Z',
    createdAt: '2025-06-20T23:34:50.981Z',
    updatedAt: '2025-06-20T23:34:50.981Z',
    storeable_asset: {
      id: '5708d646-167c-4b44-9497-530a3c8ebf6f',
      visibility: 'public',
      asset_type: 'media',
      filename: '414e1923-660c-45c4-a7fc-d7f33472d146.jpg',
      extension: 'jpg',
      mime_type: 'image/heic',
      size: '2808983',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/414e1923-660c-45c4-a7fc-d7f33472d146.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/414e1923-660c-45c4-a7fc-d7f33472d146.jpg',
      createdAt: '2025-06-20T23:34:47.236Z',
      updatedAt: '2025-06-20T23:34:47.236Z'
    }
  },
  {
    id: '5c1ae7fa-9cd8-44a4-85a8-39c739105272',
    name: '4520FB06-4AC9-4145-B4CC-819F20DF88B6.jpg',
    storeable_asset_id: 'b26eeb23-23c0-4a28-987d-a61929ace113',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:52.131Z',
    createdAt: '2025-06-20T23:34:52.136Z',
    updatedAt: '2025-06-20T23:34:52.136Z',
    storeable_asset: {
      id: 'b26eeb23-23c0-4a28-987d-a61929ace113',
      visibility: 'public',
      asset_type: 'media',
      filename: '33fcd63a-0840-4743-bfc3-a667c47aa8b9.jpg',
      extension: 'jpg',
      mime_type: 'image/jpeg',
      size: '1896240',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/33fcd63a-0840-4743-bfc3-a667c47aa8b9.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/33fcd63a-0840-4743-bfc3-a667c47aa8b9.jpg',
      createdAt: '2025-06-20T23:34:47.089Z',
      updatedAt: '2025-06-20T23:34:47.089Z'
    }
  },
  {
    id: '7f8f7a54-0b91-4332-9c98-cc8cc3eb1b70',
    name: '741A8F9B-CE78-497C-B408-D2F434453687.jpg',
    storeable_asset_id: '43e04b7e-0909-48b0-aa23-20168aec4b6e',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:51.563Z',
    createdAt: '2025-06-20T23:34:51.568Z',
    updatedAt: '2025-06-20T23:34:51.568Z',
    storeable_asset: {
      id: '43e04b7e-0909-48b0-aa23-20168aec4b6e',
      visibility: 'public',
      asset_type: 'media',
      filename: '2aebfdc1-6270-425c-929c-a9634075e23a.jpg',
      extension: 'jpg',
      mime_type: 'image/jpeg',
      size: '2604768',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/2aebfdc1-6270-425c-929c-a9634075e23a.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/2aebfdc1-6270-425c-929c-a9634075e23a.jpg',
      createdAt: '2025-06-20T23:34:47.128Z',
      updatedAt: '2025-06-20T23:34:47.128Z'
    }
  },
  {
    id: 'c54394b1-8515-414e-a306-4de74ca27930',
    name: 'A38D108F-E8EC-471B-A76E-EAB6D45E961D.jpg',
    storeable_asset_id: 'c55445a7-6de5-4c28-b260-3dd3251464ed',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:51.568Z',
    createdAt: '2025-06-20T23:34:51.573Z',
    updatedAt: '2025-06-20T23:34:51.573Z',
    storeable_asset: {
      id: 'c55445a7-6de5-4c28-b260-3dd3251464ed',
      visibility: 'public',
      asset_type: 'media',
      filename: '2fac135b-984b-44a2-ad49-7b3fc815f5e3.jpg',
      extension: 'jpg',
      mime_type: 'image/jpeg',
      size: '1268382',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/2fac135b-984b-44a2-ad49-7b3fc815f5e3.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/2fac135b-984b-44a2-ad49-7b3fc815f5e3.jpg',
      createdAt: '2025-06-20T23:34:47.087Z',
      updatedAt: '2025-06-20T23:34:47.087Z'
    }
  },
  {
    id: '4096a698-a883-4a14-9b0f-6d44c2963dae',
    name: 'DB5886F6-6B22-4E9A-8A89-0248485DB68D.jpg',
    storeable_asset_id: '882bf230-3f84-4adf-bc65-65759bc546cc',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:51.743Z',
    createdAt: '2025-06-20T23:34:51.748Z',
    updatedAt: '2025-06-20T23:34:51.748Z',
    storeable_asset: {
      id: '882bf230-3f84-4adf-bc65-65759bc546cc',
      visibility: 'public',
      asset_type: 'media',
      filename: '6fa1a388-b705-4d88-8feb-24f8b13699be.jpg',
      extension: 'jpg',
      mime_type: 'image/jpeg',
      size: '1852262',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/6fa1a388-b705-4d88-8feb-24f8b13699be.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/6fa1a388-b705-4d88-8feb-24f8b13699be.jpg',
      createdAt: '2025-06-20T23:34:47.114Z',
      updatedAt: '2025-06-20T23:34:47.114Z'
    }
  },
  {
    id: '181dbe85-a0ba-4f06-bc6b-664272afb624',
    name: 'E9B948F8-EC98-4457-B984-EAEC1798BB9B.jpg',
    storeable_asset_id: 'b2efc56d-c884-489e-96ce-4a0aa218c401',
    vessel_id: 'e57dd4c3-766c-46e4-924d-e85aa6bbee1c',
    expiration_date: '2025-06-27T23:34:50.870Z',
    createdAt: '2025-06-20T23:34:50.876Z',
    updatedAt: '2025-06-20T23:34:50.876Z',
    storeable_asset: {
      id: 'b2efc56d-c884-489e-96ce-4a0aa218c401',
      visibility: 'public',
      asset_type: 'media',
      filename: '75f557a5-ef3f-4024-9760-0c394c312238.jpg',
      extension: 'jpg',
      mime_type: 'image/jpeg',
      size: '2505426',
      size_unit_type: 'bytes',
      key: 'vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/75f557a5-ef3f-4024-9760-0c394c312238.jpg',
      download_url:
        'https://d1l4wqz3db8vco.cloudfront.net/vessel/e57dd4c3-766c-46e4-924d-e85aa6bbee1c/media/75f557a5-ef3f-4024-9760-0c394c312238.jpg',
      createdAt: '2025-06-20T23:34:47.069Z',
      updatedAt: '2025-06-20T23:34:47.069Z'
    }
  }
];
type Props = {
  open: boolean;
  onClose: () => void;
};

interface selectedIdType {
  id: string | null;
  isSelected: boolean;
}

const VesselMediaArchive: FC<Props> = ({ open, onClose }): ReactElement => {
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState<boolean>(false);
  const [openRestoreDialog, setOpenRestoreDialog] = React.useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<selectedIdType[]>([]);
  const [selectedId, setSelectedId] = useState<selectedIdType>({
    id: null,
    isSelected: false
  });
  const handleConfirmDeleteFile = () => {
    // Logic to delete the selected files
    setOpenDeleteDialog(false);
  };

  const handleConfirmRestoreFile = () => {
    // Logic to restore the selected files
    setOpenRestoreDialog(false);
  };

  useEffect(() => {
    setSelectedIds((prevSelectedIds) => {
      if (selectedId.isSelected) {
        // Add the selected ID if it is not already in the list
        return [...prevSelectedIds, { id: selectedId.id, isSelected: selectedId.isSelected }];
      } else {
        // Remove the ID from the list if it is deselected
        return prevSelectedIds.filter((item) => item.id !== selectedId.id);
      }
    });
  }, [selectedId]);

  useEffect(() => {
    // Reset selected IDs when the dialog is closed
    if (!open) {
      setSelectedIds([]);
      setSelectedId({ id: null, isSelected: false });
    }
  }, [open]);

  useEffect(() => {
    console.log('Selected IDs:', selectedIds);
  }, [selectedIds]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        scroll="paper"
        maxWidth="md"
        sx={{
          '.MuiPaper-root': {
            height: 'auto',
            paddingBottom: '40px'
          }
        }}>
        <DialogActions>
          <IconButton>
            <HighlightOffIcon onClick={onClose} />
          </IconButton>
        </DialogActions>
        <DialogTitle sx={{ padding: '0 34px', marginBottom: '30px' }}>
          <Grid container alignItems="center">
            <h2
              style={{
                margin: '0'
              }}>
              Archived Media Items
            </h2>
            <Button
              disabled={selectedIds.length === 0}
              variant="outlined"
              size="small"
              sx={{ marginLeft: '20px' }}
              onClick={() => setOpenRestoreDialog(true)}>
              Restore
            </Button>
            <Button
              disabled={selectedIds.length === 0}
              variant="contained"
              size="small"
              sx={{ marginLeft: '20px', backgroundColor: '#F44336' }}
              onClick={() => setOpenDeleteDialog(true)}>
              Delete
            </Button>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <Grid container gap={1}>
            {mockData.map((file, i) => {
              return (
                <Grid
                  gap={2}
                  item
                  key={i}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <input
                    type="checkbox"
                    onChange={(value) => {
                      setSelectedId({
                        id: file.id,
                        isSelected: value.target.checked
                      });
                    }}
                  />
                  <img src={file.storeable_asset.download_url} width={70} height={70} />
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Divider orientation="vertical" variant="middle" flexItem />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
      {openDeleteDialog && (
        <AlertDialog
          content={
            <Grid
              container
              direction="row"
              alignItems="center"
              margin={'auto'}
              justifyContent={'center'}
              textAlign={'center'}>
              <Grid item xs={10} sm={8.7} md={8.7} lg={8.7} xl={8.7}>
                <span style={modalTextStyle}>
                  Are you sure you want to delete the selected files? This action can not be undone
                </span>
              </Grid>
            </Grid>
          }
          cancelText={'No, cancel'}
          approveText={'Yes, remove'}
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          onSave={handleConfirmDeleteFile}
        />
      )}

      {openRestoreDialog && (
        <AlertDialog
          content={
            <Grid
              container
              direction="row"
              alignItems="center"
              margin={'auto'}
              justifyContent={'center'}
              textAlign={'center'}>
              <Grid item xs={10} sm={8.7} md={8.7} lg={8.7} xl={8.7}>
                <span style={modalTextStyle}>
                  Are you sure you want to restore the selected files?
                </span>
              </Grid>
            </Grid>
          }
          cancelText={'No, cancel'}
          approveText={'Yes, remove'}
          open={openRestoreDialog}
          onClose={() => setOpenRestoreDialog(false)}
          onSave={handleConfirmRestoreFile}
        />
      )}
    </>
  );
};

export default VesselMediaArchive;
